import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnInit {
  @Input() fileUploadInputs: string[] = [];
  @Input() files: any[] = [];
  @Input() blocIndex: number = 0;
  @Input() isSetting: boolean = false;

  // files: any[] = [];
  filesPreview: any[] = [];

  @Output() inputChange = new EventEmitter<{
    files: any[];
  }>();

  constructor(
    private domSanitizer: DomSanitizer,
    private apiService: ApiService
  ) {
    this.files = [];
    this.filesPreview = [];
  }

  ngOnInit() {
    this.files.forEach((file) => {
      file.file_urls.forEach((url: any) => {
        this.filesPreview.push(url);
      });
    });
  }

  onFileChange(event: any) {
    const index = event.target.id.slice(-1);

    if (index >= 0) {
      this.files[index] = event.target.files[0];
      // const url = this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(event.target.files[0]));
      const url = URL.createObjectURL(event.target.files[0]);
      this.filesPreview[index] = url;
    } else {
      this.files.push(event.target.files[0]);
      // const url = this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(event.target.files[0]));
      const url = URL.createObjectURL(event.target.files[0]);
      this.filesPreview.push(url);
    }

    if (!this.isSetting) {
      this.apiService
        .uploadArticleFile(event.target.files[0], index)
        .subscribe((res: any) => {
          if (res.modnews_article_bloc_media_id) {
            // add the id to the file object
            this.files[index].id = res.modnews_article_bloc_media_id;
            this.inputChange.emit({
              files: this.files,
            });
          }
        });
    } else {
      this.apiService
        .uploadSettingFile(event.target.files[0], index)
        .subscribe((res: any) => {
          if (res.city_setting_media_id) {
            // add the id to the file object
            this.files[index].id = res.city_setting_media_id;
            this.inputChange.emit({
              files: this.files,
            });
          }
        });
    }
  }

  pdfURL(url: any) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  removeFile(index: number) {
    //check if this.files is an array
    if (!Array.isArray(this.files)) {
      this.files = [];
      this.filesPreview = [];
    } else {
      const file = this.files[index];
      this.files.splice(index, 1);
      this.filesPreview.splice(index, 1);

      if (!file.id) return;

      if (!this.isSetting) {
        this.apiService.deleteArticleFile(file.id).subscribe((res: any) => {
        });
      } else {
        this.apiService.deleteSettingFile(file.id).subscribe((res: any) => {
        });
      }
    }
  }
}
